import { LegacyActionType } from '../../model/types/LegacyActionType';
import { getActionText } from '../getActionText/getActionText';

export const getNotificationParamsFromResponse = (
  response: any,
  type: LegacyActionType
) => {
  if (type === 'info') {
    return {
      status: 'info' as const,
      title: 'Ожидание',
      text: 'Загрузка данных',
    };
  }

  switch (response?.status) {
    case 200:
    case 201:
    case 204:
      return {
        status: 'success' as const,
        title: 'Успех',
        text: `Документ успешно ${getActionText(type)}.`,
      };

    case 400:
      return {
        status: 'danger' as const,
        title: 'Ошибка',
        text: `Ошибка при ${getActionText(type)}ии документа.`,
      };

    case 401:
      return {
        status: 'danger' as const,
        title: 'Ошибка',
        text: 'Ошибка при авторизации',
      };

    case 403:
      return {
        status: 'danger' as const,
        title: 'Ошибка',
        text: 'Доступ к операции запрещен.',
      };

    case 404:
      return {
        status: 'danger' as const,
        title: 'Ошибка',
        text: 'Ресурс не найден.',
      };

    case 500:
      return {
        status: 'danger' as const,
        title: 'Ошибка',
        text: 'Внутренняя ошибка сервера.',
      };

    default:
      return {
        status: 'danger' as const,
        title: 'Ошибка',
        text: 'Неизвестная ошибка.',
      };
  }
};
